var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22C23 22.5523 22.5523 23 22 23H14.8C14.2477 23 13.8 22.5523 13.8 22V14.8C13.8 14.2477 14.2477 13.8 14.8 13.8H22C22.5523 13.8 23 14.2477 23 14.8V22ZM9.2 22C9.2 22.5523 8.75228 23 8.2 23H0.999999C0.447714 23 0 22.5523 0 22V14.8C0 14.2477 0.447715 13.8 1 13.8H8.2C8.75229 13.8 9.2 14.2477 9.2 14.8V22ZM23 8.2C23 8.75229 22.5523 9.2 22 9.2H14.8C14.2477 9.2 13.8 8.75228 13.8 8.2V0.999999C13.8 0.447714 14.2477 0 14.8 0H22C22.5523 0 23 0.447715 23 1V8.2ZM9.2 8.2C9.2 8.75229 8.75228 9.2 8.2 9.2H0.999999C0.447714 9.2 0 8.75228 0 8.2V0.999999C0 0.447714 0.447715 0 1 0H8.2C8.75229 0 9.2 0.447715 9.2 1V8.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6a43d23865d623510066866bc737784f.svg";
export { ForwardRef as ReactComponent };